module.exports = __webpack_public_path__ + "static/media/folder-tree.66c04667.svg";